export default __webpack_public_path__ + "static/media/learner-dashboard-advanced.3694ebf5.png";